var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCs5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 277,
    viewBox: "0 0 243 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2253_783",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 242,
    height: 276
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 241.815,
    height: 275.685,
    fill: "#972682"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2253_783)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -79.4658,
    y: -0.974365,
    width: 364.005,
    height: 276.659,
    fill: "#972682"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M242.124 124.352L236.365 124.352C236.365 59.5899 184.676 6.91736 121.124 6.91736C57.5716 6.91736 5.88319 59.5899 5.88319 124.352L5.88319 275.415L0.124023 275.415L0.124025 124.352C0.124026 56.362 54.4041 1.04855 121.124 1.04855C187.844 1.04856 242.124 56.362 242.124 124.352Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.957 124.353L222.197 124.353C222.197 67.572 176.844 21.3552 121.124 21.3552C65.4042 21.3552 20.0509 67.572 20.0509 124.353L20.0508 276.002L14.2917 276.002L14.2917 124.353C14.2917 64.3148 62.2079 15.4864 121.124 15.4864C180.04 15.4864 227.957 64.3148 227.957 124.353Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M213.789 124.352L208.03 124.352C208.03 75.5237 169.04 35.7918 121.124 35.7918C73.2076 35.7918 34.2181 75.5237 34.2181 124.352L34.2181 275.415L28.459 275.415L28.459 124.352C28.459 72.2958 70.0401 29.923 121.124 29.923C172.208 29.923 213.789 72.2665 213.789 124.352Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.621 124.352L193.862 124.352C193.862 83.4759 161.237 50.2291 121.124 50.2291C81.0115 50.2291 48.3859 83.4759 48.3859 124.352L48.3859 275.415L42.6267 275.415L42.6267 124.352C42.6267 80.248 77.8439 44.3603 121.124 44.3603C164.404 44.3603 199.621 80.248 199.621 124.352Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.454 124.352L179.694 124.352C179.694 91.4281 153.433 64.6664 121.124 64.6664C88.8149 64.6664 62.5531 91.4281 62.5531 124.352L62.5531 275.415L56.7939 275.415L56.7939 124.352C56.7939 88.2003 85.6473 58.7976 121.124 58.7976C156.6 58.7976 185.454 88.2003 185.454 124.352Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.286 124.352L165.527 124.352C165.527 99.4097 145.6 79.1037 121.124 79.1037C96.6475 79.1037 76.7208 99.4097 76.7208 124.352L76.7208 275.415L70.9617 275.415L70.9617 124.352C70.9617 96.1525 93.4511 73.2348 121.124 73.2348C148.797 73.2348 171.286 96.1525 171.286 124.352Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.119 124.352L151.36 124.352C151.36 107.362 137.797 93.5409 121.124 93.5409C104.451 93.5409 90.8883 107.362 90.8883 124.352L90.8883 275.415L85.1292 275.415L85.1292 124.352C85.1292 104.134 101.284 87.6721 121.124 87.6721C140.964 87.6721 157.119 104.105 157.119 124.352Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.951 124.352L137.192 124.352C137.192 115.314 129.993 107.978 121.124 107.978C112.255 107.978 105.056 115.314 105.056 124.352L105.056 275.415L99.2969 275.415L99.2969 124.352C99.2969 112.086 109.087 102.109 121.124 102.109C133.161 102.109 142.951 112.086 142.951 124.352Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs5);
export default __webpack_public_path__ + "static/media/cs5.44d44676997aeb6c9633e82d5d83d8f1.svg";
export { ForwardRef as ReactComponent };